module.exports = __webpack_public_path__ + "img/CS-ECONew_Overview-Rear_1.c566df37.jpg";